import React from "react";
import theme from "../../theme";
import { CLAIM_STATE_META, categoryLabel } from "./utils";

const baseChip = {
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
  padding: "3px 10px",
  borderRadius: "999px",
  fontSize: "12px",
  fontFamily: theme.fontFamily.MARKPROBOLD,
  lineHeight: "18px",
  whiteSpace: "nowrap",
};

// Claim state chip: PENDING=amber, REDEEMED=green, FAILED=red.
export function ClaimStateChip({ state }) {
  const meta = CLAIM_STATE_META[state] || {
    label: state || "Unknown",
    color: theme.colors.Violet,
    bg: theme.colors.Zumthor,
  };
  return (
    <span
      style={{ ...baseChip, color: meta.color, backgroundColor: meta.bg }}
      title={meta.description || ""}
      aria-label={`Claim state: ${meta.label}`}
    >
      <span
        style={{
          width: "7px",
          height: "7px",
          borderRadius: "50%",
          backgroundColor: meta.color,
        }}
      />
      {meta.label}
    </span>
  );
}

// Active / inactive chip for a bonus.
export function ActiveChip({ active }) {
  const color = active ? theme.colors.ApproveGreen : theme.colors.Violet;
  const bg = active ? "#DCFCE7" : theme.colors.Gallery;
  return (
    <span
      style={{ ...baseChip, color, backgroundColor: bg }}
      aria-label={active ? "Active" : "Inactive"}
    >
      {active ? "Active" : "Inactive"}
    </span>
  );
}

// Neutral category chip (data-driven label).
export function CategoryChip({ category }) {
  return (
    <span
      style={{
        ...baseChip,
        color: theme.colors.DodgerBlue,
        backgroundColor: theme.colors.Zumthor,
      }}
    >
      {categoryLabel(category)}
    </span>
  );
}
